import FormikControl from '../../../components/formik-control'

const MapField = ({ importedField, prospectFields, ...rest }) => {
  return (
    <FormikControl control="select" label={importedField} name={importedField} options={prospectFields} {...rest} />
  )
}

export default MapField
